<div
  #modalContents
  [class]="lmodalContentsClassWithWidth"
  aria-modal="true"
  role="dialog"
  aria-labelledby="plan-save-modal-title"
>
  <div #modalHead [class]="lmodalHeaderClass">
    <div class="p-modal-head01">
      <h1 id="plan-save-modal-title" class="p-modal-head01__title" [innerHTML]="modalTitle"></h1>
      <button id="close-plan-save-modal" class="p-modal-head01__close js-modal-close" (click)="clickClose()">
        <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
      </button>
    </div>
  </div>

  <div #modalBody [class]="lmodalBodyClass">
    <div class="lmodalBodyClass__plan-name-form-wrapper">
      <form [formGroup]="inputFG">
        <asw-input
          id="plan-save-modal-plan-name-input"
          [label]="'label.planTitle' | staticMsg"
          [placeholder]="'placeholder.planName' | staticMsg"
          formControlName="planNameInput"
          maxlength="70"
          required
        ></asw-input>
      </form>
    </div>
  </div>

  <div #modalFooter [class]="lmodalFooterClass">
    <div class="p-modal-foot01">
      <asw-button
        id="plan-save-modal-save-plan-btn"
        (click$)="savePlan()"
        throttleClick
        [label]="'label.savePlan' | staticMsg"
      ></asw-button>
    </div>
  </div>
</div>
